<template>
  <q-form ref="editForm">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <!-- 기본정보 -->
      <c-card title="기본정보" class="cardClassDetailForm">
        <template slot="card-button">
          <q-btn-group outline>
            <!-- 기본정보 저장 -->
            <c-btn v-show="!disabled" :url="updateUrl" :isSubmit="isSave" :param="accidentInfo" mappingType="PUT" label="기본정보 저장" icon="save" @beforeAction="saveAccident" @btnCallback="saveCallback" />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <c-textarea :editable="editable" :disabled="disabled" :rows="5" label="재해발생원인(인적)" name="accidentCause" v-model="accidentInfo.accidentCause"> </c-textarea>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <c-textarea :editable="editable" :disabled="disabled" :rows="5" label="재해발생원인(물적)" name="accidentCauseM" v-model="accidentInfo.accidentCauseM"> </c-textarea>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <c-textarea :editable="editable" :disabled="disabled" :rows="5" label="재해발생원인(환경적)" name="accidentCauseE" v-model="accidentInfo.accidentCauseE"> </c-textarea>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <c-textarea :editable="editable" :disabled="disabled" :rows="5" label="재발방지대책(공학적)" name="engineeringRecurrence" v-model="accidentInfo.engineeringRecurrence"> </c-textarea>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <c-textarea :editable="editable" :disabled="disabled" :rows="5" label="재발방지대책(관리적)" name="managementRecurrence" v-model="accidentInfo.managementRecurrence"> </c-textarea>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <c-textarea :editable="editable" :disabled="disabled" :rows="5" label="환경안경팀 의견" name="managerOpinion" v-model="accidentInfo.managerOpinion"> </c-textarea>
          </div>
        </template>
      </c-card>
    </div>
    <c-table ref="tableImpr" title="수시 위험성평가" :columns="gridImpr.columns" :data="accidentInfo.accidentImproveModelList" :gridHeight="gridHeight" :merge="gridImpr.merge" selection="multiple" rowKey="causesNo" :usePaging="false" :hideBottom="true" :filtering="false" :columnSetting="false" :editable="editable && !disabled" @table-data-change="tableDataChange">
      <template slot="table-button">
        <q-btn-group outline>
          <!-- 추가 -->
          <c-btn v-if="editable && !disabled" label="LBLADD" :showLoading="false" icon="add" @btnClicked="addImpr" />
          <!-- 저장 -->
          <c-btn v-if="editable && !disabled && accidentInfo.accidentImproveModelList.length > 0" :url="updateCauseUrl" :isSubmit="isSave2" :param="accidentInfo.accidentImproveModelList" mappingType="PUT" label="LBLSAVE" icon="save" @beforeAction="saveImpr" @btnCallback="saveCallback" />
          <c-btn v-if="editable && !disabled && accidentInfo.accidentImproveModelList.length > 0" label="LBLREMOVE" :showLoading="false" icon="remove" @btnClicked="removeImpr" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'customCol'">
          <component :is="imprComponent" :col="col" :props="props" 
            :inputEditable="editable && !disabled" :isImmShow="true" tableKey="causesNo" 
            ibmTaskTypeCd="ITT0000040" ibmTaskUnderTypeCd="ITTU000065" 
            :requestContentsCols="['accidentName', 'causeTypeName', 'accidentCause', 'riskLevelNameB', 'riskLevelNameA', 'improvingMeasures']"
            @imprChange="imprChange" 
          />
        </template>
      </template>
    </c-table>
    <c-card title="위험성 판단 기준" class="cardClassDetailForm accident" height="220px">
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <table class="riskCriteriaTable">
            <thead>
              <tr>
                <th style="width:16%">위험성 수준</th>
                <th>판단 기준</th>
                <th style="width:15%">허용 가능 여부</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="riskLevelCell riskLevelHigh"><b class="text-red q-mr-sm">상(빨강)</b>: 매우높음</td>
                <td class="riskCriteriaCell">
                  · 사고 발생 시 사망 또는 장애가 남을 수 있는 위험<br />
                  · 산업안전보건법에 따른 기준을 만족시키지 못한 경우
                </td>
                <td rowspan="2">허용 불가능<br />(개선 후 작업)</td>
              </tr>
              <tr>
                <td class="riskLevelCell riskLevelMid"><b class="text-amber q-mr-sm">중(노랑)</b>: 보통</td>
                <td class="riskCriteriaCell">
                  · 사고 발생 시 3일 이상의 휴업이 필요한 경우<br />
                  · 아차사고 사례가 있는 경우
                </td>
              </tr>
              <tr>
                <td class="riskLevelCell riskLevelLow"><b class="text-green q-mr-sm">하(초록)</b>: 매우낮음</td>
                <td class="riskCriteriaCell">
                  · 3일 미만의 휴업 또는 작업 수행에 영향을 미치지 않는 경미한 부상 또는 질병이 예상되는 경우
                </td>
                <td>허용가능</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </c-card>
    <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>

<script>
import { uid } from 'quasar';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'accident-cause-prevention',
  props: {
    param: {
      type: Object,
      default: () => ({
        iimAccidentId: '',
        stepCd: '',
        regUpdateBtnData: {
          title: '사고등록',
          flag: false,
          research: '',
          planResearch: '',
          recResearch: '',
        },
      }),
    },
    height: {
      type: String,
      default: function () {
        return '';
      },
    },
    accidentInfo: {
      type: Object,
      default: () => ({
        accidentName: '',
        occurrenceDeptCd: '',
        accidentStatusCd: '',
        accidentCause: '',
        accidentCauseM: '',
        accidentCauseE: '',
        managerOpinion: '',
        engineeringRecurrence: '',
        managementRecurrence: '',
        accidentImproveModelList: [],
      }),
    },
  },
  data() {
    let causeTypeItems = [
      { code: 'ICDC000001', codeName: '기술적' },
      { code: 'ICDC000002', codeName: '교육적' },
      { code: 'ICDC000003', codeName: '관리적' },
    ];
    return {
      editable: true,
      causeTypeItems: causeTypeItems,
      gridImpr: {
        columns: [
          {
            required: true,
            name: 'causeTypeCd',
            field: 'causeTypeCd',
            // 원인구분
            label: 'LBL00001560',
            align: 'center',
            style: 'width:10%',
            type: 'select',
            comboItems: causeTypeItems,
            sortable: false,
          },
          {
            required: true,
            name: 'accidentCause',
            field: 'accidentCause',
            // 사고원인
            label: 'LBL00001561',
            align: 'left',
            type: 'text',
            style: 'width:25%',
            sortable: false,
          },
          {
            label: '개선전 위험성',
            align: 'center',
            child: [
              {
                name: 'brl00000001',
                field: 'brl00000001',
                label: '상',
                align: 'center',
                style: 'width:30px',
                sortable: false,
                type: 'check',
                checkIcon: 'task_alt',
                uncheckIcon: 'radio_button_unchecked',
                'true': 'Y',
                'false': 'N',
                color: 'red', 
              },
              {
                name: 'brl00000005',
                field: 'brl00000005',
                label: '중',
                align: 'center',
                style: 'width:30px',
                sortable: false,
                type: 'check',
                checkIcon: 'task_alt',
                uncheckIcon: 'radio_button_unchecked',
                'true': 'Y',
                'false': 'N',
                color: 'amber', 
              },
              {
                name: 'brl00000010',
                field: 'brl00000010',
                label: '하',
                align: 'center',
                style: 'width:30px',
                sortable: false,
                type: 'check',
                checkIcon: 'task_alt',
                uncheckIcon: 'radio_button_unchecked',
                'true': 'Y',
                'false': 'N',
                color: 'green', 
              },
            ],
          },
          {
            label: '개선진행',
            align: 'center',
            child: [
              {
                name: 'improvingMeasures',
                field: 'improvingMeasures',
                label: '개선대책',
                align: 'left',
                style: 'width:20%',
                type: 'text',
                sortable: false,
              },
              {
                name: 'customCol',
                field: 'customCol',
                label: '개선번호/진행상태',
                align: 'center',
                style: 'width:15%',
                type: 'custom',
                sortable: false,
              },
            ],
          },
          {
            label: '개선후 위험성',
            align: 'center',
            child: [
              {
                name: 'arl00000001',
                field: 'arl00000001',
                label: '상',
                align: 'center',
                style: 'width:30px',
                sortable: false,
                type: 'check',
                checkIcon: 'task_alt',
                uncheckIcon: 'radio_button_unchecked',
                'true': 'Y',
                'false': 'N',
                color: 'red'
              },
              {
                name: 'arl00000005',
                field: 'arl00000005',
                label: '중',
                align: 'center',
                style: 'width:30px',
                sortable: false,
                type: 'check',
                checkIcon: 'task_alt',
                uncheckIcon: 'radio_button_unchecked',
                'true': 'Y',
                'false': 'N',
                color: 'amber'
              },
              {
                name: 'arl00000010',
                field: 'arl00000010',
                label: '하',
                align: 'center',
                style: 'width:30px',
                sortable: false,
                type: 'check',
                checkIcon: 'task_alt',
                uncheckIcon: 'radio_button_unchecked',
                'true': 'Y',
                'false': 'N',
                color: 'green'
              },
            ],
          },
        ],
        data: [],
        height: '315px',
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '80%',
        param: {},
        closeCallback: null,
      },
      imprData: null,
      completeUrl: '',
      updateUrl: '',
      updateCauseUrl: '',
      deleteUrl: '',
      searchUrl: '',
      isSave: false,
      isSave2: false,
      getUrl: '',
    };
  },
  computed: {
    gridHeight() {
      let numHeight = this.height ? Number(this.$_.replace(this.height, 'px', '')) - 560 : 200;
      return numHeight + 'px';
    },
    isEnvSafDept() {
      return this.$_.indexOf(this.$store.getters.auths, 'SAGI000027') > -1 || this.$store.getters.user.empNo === 'admin';
    },
    disabled() {
      return this.param.stepCd === 'ISPC000005' && !this.isEnvSafDept;
    },
    // 개선요청 Component
    imprComponent() {
      let components = () => import(`${'@/pages/common/ibm/tableImpr.vue'}`);
      return components;
    },
  },
  watch: {
    'accidentInfo.accidentImproveModelList': {
      handler(list) {
        this.$_.forEach(list, row => {
          if (row.causeTypeName === undefined) {
            this.$set(row, 'causeTypeName', this.getCauseTypeName(row.causeTypeCd));
          }
          if (row.accidentName === undefined) {
            this.$set(row, 'accidentName', this.accidentInfo.accidentName);
          }
        });
      },
      immediate: true,
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.updateUrl = transactionConfig.sop.iim.accident.process.prevention.update.url;
      this.updateCauseUrl = transactionConfig.sop.iim.accident.process.prevention.update.cause.url;
      this.deleteUrl = transactionConfig.sop.iim.accident.process.prevention.delete.url;
    },
    // 개선창 닫기 후
    imprChange() {
      this.$refs['tableImpr'].$refs['compo-table'].resetVirtualScroll();
    },
    saveAccident() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.accidentInfo.regUserId = this.$store.getters.user.userId;
              this.accidentInfo.chgUserId = this.$store.getters.user.userId;
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveImpr() {
      if (this.$comm.validTable(this.gridImpr.columns, this.accidentInfo.accidentImproveModelList)) {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGSAVE', // 저장하시겠습니까?
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.accidentInfo.regUserId = this.$store.getters.user.userId;
            this.accidentInfo.chgUserId = this.$store.getters.user.userId;
            this.isSave2 = !this.isSave2;
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      }
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('getDetail');
    },
    addImpr() {
      this.accidentInfo.accidentImproveModelList.splice(0, 0, {
        iimAccidentId: this.param.iimAccidentId,
        accidendtName: this.accidentInfo.accidendtName || null,
        causesNo: uid(),
        arl00000001: 'N',
        arl00000005: 'N',
        arl00000010: 'N',
        brl00000001: 'N',
        brl00000005: 'N',
        brl00000010: 'N',
        regUserId: this.$store.getters.user.userId,
        editFlag: 'C',
      });
    },
    removeImpr() {
      let selectData = this.$refs['tableImpr'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGREMOVE', // 삭제하시겠습니까?,
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData),
            };
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$refs['tableImpr'].$refs['compo-table'].clearSelection();
              this.$emit('getDetail');
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      }
    },
    getCauseTypeName(cd) {
      let item = this.$_.find(this.causeTypeItems, { code: cd });
      return item ? item.codeName : '';
    },
    tableDataChange(props, col) {
      if (!props.row[col.name]) return;
      if (col.name === 'causeTypeCd') {
        this.$set(props.row, 'causeTypeName', this.getCauseTypeName(props.row['causeTypeCd']));
      } else if (['brl00000001', 'brl00000005', 'brl00000010'].includes(col.name)) {
        if (props.row[col.name] === 'Y') {
          this.$_.forEach(['brl00000001', 'brl00000005', 'brl00000010'], name => {
            if (name !== col.name) this.$set(props.row, name, 'N');
          });
          this.$set(props.row, 'riskLevelB', this.$_.toUpper(col.name.substring(1)));
        } else {
          this.$set(props.row, 'riskLevelB', '');
        }
      } else if (['arl00000001', 'arl00000005', 'arl00000010'].includes(col.name)) {
        if (props.row[col.name] === 'Y') {
          this.$_.forEach(['arl00000001', 'arl00000005', 'arl00000010'], name => {
            if (name !== col.name) this.$set(props.row, name, 'N');
          });
          this.$set(props.row, 'riskLevelA', this.$_.toUpper(col.name.substring(1)));
        } else {
          this.$set(props.row, 'riskLevelA', '');
        }
      }
    },
  },
};
</script>

<style scoped>
.riskCriteriaTable {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
.riskCriteriaTable th,
.riskCriteriaTable td {
  border: 1px solid #c9c8c8;
  padding: 8px 12px;
  font-size: 0.9em;
  text-align: center;
  vertical-align: middle;
}
.riskCriteriaTable thead th {
  background-color: #f5f5f5;
  font-weight: 700;
}
.riskCriteriaTable .riskCriteriaCell {
  text-align: left;
  line-height: 1.6;
}
.accident ::v-deep .q-card__section.customCardbody {
  padding-top: 0 !important;
}
</style>
